// components/common/Journey/SafetyNoticeModal.tsx
import { useState } from "react";
import Button from "../../../components/common/Button/Button";
import Modal from "../../../components/common/Modal/Modal";
import {
	SAFETY_NOTICE_TITLE,
	SAFETY_NOTICE_INTRO,
	SAFETY_NOTICE_SECTIONS,
	SAFETY_NOTICE_TIP,
} from "./journeySafetyNotice";
import styles from "./Journey.module.css";

interface SafetyNoticeModalProps {
	isOpen: boolean;
	onClose: () => void;
	/**
	 * "view"  – uživatel si text otevřel dobrovolně z panelu, stačí ho zavřít.
	 * "gate"  – uživatel se pokusil skrýt sekci Začínáme; musí text potvrdit
	 *           zaškrtnutím, než se `onConfirm` zpřístupní.
	 */
	mode: "view" | "gate";
	onConfirm?: () => void;
}

const SafetyNoticeContent = () => (
	<div className={styles.noticeContent}>
		<p className={styles.noticeIntro}>{SAFETY_NOTICE_INTRO}</p>
		{SAFETY_NOTICE_SECTIONS.map((section) => (
			<p key={section.heading} className={styles.noticeSection}>
				{section.heading && <strong>{section.heading} – </strong>}
				{section.body}
			</p>
		))}
		<p className={styles.noticeTip}>{SAFETY_NOTICE_TIP}</p>
	</div>
);

const SafetyNoticeModal = ({ isOpen, onClose, mode, onConfirm }: SafetyNoticeModalProps) => {
	const [confirmed, setConfirmed] = useState(false);

	const handleClose = () => {
		setConfirmed(false);
		onClose();
	};

	const handleConfirm = () => {
		if (!confirmed) return;
		setConfirmed(false);
		onConfirm?.();
	};

	return (
		<Modal isOpen={isOpen} onClose={handleClose} title={`⚠️ ${SAFETY_NOTICE_TITLE}`} size="medium">
			<SafetyNoticeContent />

			{mode === "gate" ? (
				<div className={styles.noticeGateFooter}>
					<label className={styles.noticeCheckboxRow}>
						<input
							type="checkbox"
							checked={confirmed}
							onChange={(e) => setConfirmed(e.target.checked)}
						/>
						<span>Přečetl/a jsem a rozumím výše uvedeným informacím.</span>
					</label>
					<div className={styles.completeActions}>
						<Button variant="secondary" onClick={handleClose}>
							Zpět
						</Button>
						<Button variant="primary" onClick={handleConfirm} disabled={!confirmed}>
							Skrýt začínáme
						</Button>
					</div>
				</div>
			) : (
				<div className={styles.completeActions}>
					<Button variant="primary" onClick={handleClose}>
						Rozumím
					</Button>
				</div>
			)}
		</Modal>
	);
};

export default SafetyNoticeModal;
